import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './core/auth-token.interceptor';
import { supplierAuthInterceptor } from './features/painel/interceptors/supplier-auth.interceptor';
import { casingNormalizerInterceptor } from './core/casing-normalizer.interceptor';
import { authRefreshInterceptor } from './core/interceptors/auth-refresh.interceptor';
// import { credentialsSanitizerInterceptor } from './core/credentials-sanitizer.interceptor';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([
      authTokenInterceptor, 
      supplierAuthInterceptor, 
      authRefreshInterceptor,
      casingNormalizerInterceptor
    ]))
  ]
};

